import styled from 'styled-components';
import { getToken } from '@optimus-web/common';
import { OptimusTextKey, useLocalization } from '@optimus-web/localization';
import { commonSkeletonStyles } from './style';

interface SkeletonTextProps {
    width?: string;
    fontSize?: number;
}

export const SkeletonText = styled.div.attrs<SkeletonTextProps>(() => {
    const { t } = useLocalization();
    return {
        role: 'status',
        'aria-busy': true,
        'aria-live': 'polite',
        'aria-label': t(OptimusTextKey.Loading),
    };
})<SkeletonTextProps>`
    ${commonSkeletonStyles};
    border-radius: ${getToken('borderRadius100')}px;
    width: ${(props) => props.width};
    max-width: 100%;
    height: ${(props) => props.fontSize}px;
`;

SkeletonText.defaultProps = {
    width: '80px',
    fontSize: 12,
};
